import {Button, Flex, useMatchBreakpoints, useModal} from "@pancakeswap/uikit"
import useAccountActiveChain from "hooks/useAccountActiveChain";
import ConfirmFaucetModal from "./ConfirmFaucetModal"
import {useActiveChainId} from "../../hooks/useActiveChainId";

export default function Faucet() {
  const { account, chainId } = useAccountActiveChain()
  const { isWrongNetwork } = useActiveChainId()
  const { isMobile } = useMatchBreakpoints()

  const [ConfirmFaucetModel] = useModal(
      <ConfirmFaucetModal isWrongNetwork={isWrongNetwork} chainId={chainId} account={account}/>,
      true,
      true,
      'confirmFaucetModal',
  )

    return (
        <Flex alignItems="center" justifyContent="space-between" height="100%" px="16px">
            <Button disabled={(!account || isWrongNetwork)}
                    scale="sm"
                    onClick={() => ConfirmFaucetModel()}>
                <span hidden={isMobile}>Faucet</span>
                <span hidden={!isMobile}>FC</span>
            </Button>
        </Flex>
    )
}
